module.exports = __webpack_public_path__ + "54ef9cbf851e0e50dec0cdcd01d7777e.svg";